/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {useEffect, useState} from 'react';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {Event} from "../GoogleAnalytics";
import Snackbar from '@mui/material/Snackbar';
import ServiceSubscriptionsTab from "./ServiceSubscriptionsTab";
import MonitoringSubscriptionsTab from "./MonitoringSubscriptionsTab";
import Loader from "../Loader/Loader";
import PartnerService from "../../services/partner.service";

const Subscriptions = ({attributeList, currentPartnerId}) => {
    const csvBaseName = "Subscriptions.csv";
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState(null);
    const [showMessage, setShowMessage] = useState(false);
    const [contractTypes, setContractTypes] = useState([]);
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!currentPartnerId) {
            setContractTypes([]);
            setLoading(false);
            return;
        }

        const isProOnly = isNaN(parseInt(currentPartnerId));

        if (isProOnly) {
            // Pro-only partner: contract type lives on the TT shadow twin.
            // getpartnerproperties auto-routes to /partners/partnerpropertiesbypro for non-integer IDs.
            PartnerService.getpartnerproperties(currentPartnerId)
                .then(propsResponse => {
                    const contractTypeProp = Array.isArray(propsResponse)
                        ? propsResponse.find(p => p.name === "ContractType")
                        : null;
                    if (contractTypeProp?.value) {
                        setContractTypes(contractTypeProp.value.split(',').filter(t => t));
                    } else {
                        setContractTypes([]);
                    }
                })
                .catch(e => {
                    console.log("Could not fetch partner properties for subscriptions:", e);
                    setContractTypes([]);
                })
                .finally(() => setLoading(false));
        } else {
            // Legacy TT partner: contract type comes from the attributeList prop.
            if (attributeList && attributeList.length > 0) {
                const contractTypeValue = attributeList.find(
                    x => x.name === "ContractType" && x.organizationId === currentPartnerId
                );
                if (contractTypeValue?.value) {
                    setContractTypes(contractTypeValue.value.split(',').filter(t => t));
                } else {
                    setContractTypes([]);
                }
            } else {
                setContractTypes([]);
            }
            setLoading(false);
        }
    }, [attributeList, currentPartnerId]);
    
    const handleFilteredChange = (data) =>{
        setData(data);
    }
    const convertToCSV = (jsonArray) => {
        let csvRows = [];

        if (!jsonArray || jsonArray.length === 0) {
            return '';
        }

        const headers = Object.keys(jsonArray[0]);
        csvRows.push(headers.join(','));

        for (const obj of jsonArray) {
            const values = headers.map(header => {
                let val = obj[header] ?? ''; // null undefined check

                // formatting
                val = String(val).replace(/"/g, '""');
                if (val.includes(',') || val.includes('\n') || val.includes('"')) {
                    val = `"${val}"`;
                }
                return val;
            });
            csvRows.push(values.join(','));
        }

        return csvRows.join('\n');
    }

    const downloadCSV = (data) => {
        Event("Download Data Clicked", "User clicked download data button in Partner Subscriptions", "Download Data Clicked");
        let filenameWithDate = csvBaseName;
        const csvContent = "data:text/csv;charset=utf-8," + encodeURIComponent(convertToCSV(data));

        const link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", filenameWithDate || "data.csv");
        document.body.appendChild(link);
        link.click();
    }
    const handleDownloadData =() =>{
        downloadCSV(data);
    }
    
    if(loading) {
        return  <Loader />
       
    }

    let downloadBtn =
        <div className="row no-gutters alerts-tab-wrapper margin-0-20 pad-10-0">
            <div className="btn-right pad-30">
                <button className="primary-btn btn-large width-150" onClick={handleDownloadData}>Download Data</button>
            </div>
        </div>;
    return (
        <div sx={(theme)=>({
            [theme.breakpoints.down('md')]: {
                marginLeft: '-225px !important',
            },
        })}>
            <div className="infoPage">

                <h2 className="pageTitle dashboard-title" id="tabelLabel">
                    Subscriptions
                </h2>
                {contractTypes.length > 0 && <div>
                    <div className="row no-gutters alerts-tab-wrapper margin-0-20 pad-10-0">
                        <div className="btn-right pad-30">
                            <button className="primary-btn btn-large width-150" onClick={handleDownloadData}>Download Data</button>
                        </div>
                    </div>
                    <Tabs class="nav nav-tabs">
                        <TabList class="nav-item">
                            {contractTypes.map((item, index) => (<Tab key={index}>{item}</Tab>))}
                        </TabList>
                        {contractTypes.map((item, index) => (
                            <TabPanel key={index}>
                                {item.toLowerCase() === "service" ?
                                    <ServiceSubscriptionsTab id={currentPartnerId} onFilterChange={handleFilteredChange}/> :
                                    item.toLowerCase() === "monitoring" ?
                                        <MonitoringSubscriptionsTab id={currentPartnerId} onFilterChange={handleFilteredChange}/>
                                        : null}
                            </TabPanel>
                        ))}
                    </Tabs>
                </div>
                }
                <Snackbar 
                    open={showMessage} 
                    message={message}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center' }} 
                    autoHideDuration={6000} 
                />
            </div>
        </div>
    );
}

export default Subscriptions;